import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'lib/@mui';

import SelectComponent from 'containers/Ezlo/EzloMeshbot/components/SelectComponent';
import { info } from 'containers/Ezlo/EzloMeshbot/utils';
import { buildUserLockOperationActionData } from 'containers/Ezlo/EzloMeshbot/utils/deviceNode/buildUserLockOperationActionData';
import { useTranslate } from 'features/languages';

/**
 * Action selector for an isUserLockOperation capability. Options come in as the `actionOptions` prop (from the config,
 * resolved once by the container), so this component is config-free. Store-driven: reads the current value from props
 * and writes the selection back through onDataUpdate — no local state.
 * @param {object} props
 * @returns {JSX.Element}
 */
const SelectUserLockOperationAction = ({ actionOptions = [], items, deviceId, selectedAction, onDataUpdate }) => {
    const { t } = useTranslate();

    const handleSelectAction = (event) => {
        onDataUpdate(buildUserLockOperationActionData(actionOptions, items, deviceId, event.target.value));
    };

    return (
        <SelectComponent value={selectedAction} label={info.hints.action} onChange={handleSelectAction}>
            {actionOptions.map(({ value, label }) => (
                <MenuItem key={value} value={value}>
                    {t(label)}
                </MenuItem>
            ))}
        </SelectComponent>
    );
};

export default SelectUserLockOperationAction;

SelectUserLockOperationAction.propTypes = {
    actionOptions: PropTypes.array,
    items: PropTypes.array,
    deviceId: PropTypes.string,
    selectedAction: PropTypes.string,
    onDataUpdate: PropTypes.func,
};
